/**
 * subFormulaMap — id -> {name, expression, weight} for every subformula of a
 * Flow Optimizer formula, so the score hover can show "Profit momentum (60%)"
 * (not "__sub_sf_…") and reveal the formula each group actually evaluates.
 * Weight is the normalized share within its group, set only when the group is
 * weighted (matches the eval).
 * Split out of FlowOptimizerLivePreviewContext (over the file limit).
 * For Media Devoted | Created By Ciro Autiero
 */

import { normalizeSubformulaWeights, type FlowOptimizerConfig } from '@trafficpulse/shared';

export interface SubFormulaInfo {
  name: string;
  expression: string;
  weight?: number;
}

export function subFormulaMap(
  formula: FlowOptimizerConfig['formula'],
): Map<string, SubFormulaInfo> {
  const map = new Map<string, SubFormulaInfo>();
  for (const group of formula?.groups ?? []) {
    const subs = group.blocks?.subformulas ?? [];
    const norm = subs.some((s) => typeof s.weight === 'number')
      ? normalizeSubformulaWeights(subs)
      : null;
    for (const sub of subs) {
      map.set(sub.id, {
        name: sub.name?.trim() || 'subformula',
        expression: (sub.expression ?? '').trim(),
        weight: norm ? norm[sub.id] : undefined,
      });
    }
  }
  return map;
}
